// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__3LsXM","checkboxCol":"Table_checkboxCol__1EqB8","emailCol":"Table_emailCol__2pG1b","actionCol":"Table_actionCol__2jzoO"};